import React from 'react';
import locale from "locale";
import { FormControl, FormGroup, ControlLabel } from "react-bootstrap";
import { CHECKBOX_SELECT_LIST } from "../constants";

const RenderField = ({field, value = '', label = '',placeholder = '', onChange}) => {
    if (field?.type && (field?.type === 'checkbox' || field?.type === 'disclaimer')) {
        return (
            <FormGroup>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    name={field.name}
                    componentClass="select"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                >
                    <option value="" disabled>Выберете значение</option>
                    {CHECKBOX_SELECT_LIST.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option[`label_${locale.currentLocaleName}`]}
                        </option>
                    ))}
                </FormControl>
            </FormGroup>
        )
    }

    if (field?.type && field?.type === 'select') {
        return (
            <FormGroup>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    name={field.name}
                    componentClass="select"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                >
                    <option value="" disabled>Выберете значение</option>
                    {
                        field?.options?.length
                            ? field.options.map((option) => (
                                <option key={option.id} value={option.value}>
                                    {option[`label_${locale.currentLocaleName}`]}
                                </option>
                            ))
                            : <></>
                    }
                </FormControl>
            </FormGroup>
        )
    }

    if (field?.type && field?.type === 'tel') {
        return (
            <FormGroup>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    name={field.name}
                    type={field?.type}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                />
            </FormGroup>
        )
    }

    return (
        <FormGroup>
            <ControlLabel>{label}</ControlLabel>
            <FormControl
                name={field.name}
                type={field?.type ?? 'text'}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
            />
        </FormGroup>
    )
};

export default RenderField;
